// export const EXAMPLE = 'example';
// export const ANOTHER_EXAMPLE = 'another-example';
export const REIMBURSIFY_UPGRADE_BUTTON = 'reimbursify-upgrade-button';
export const REIMBURSIFY_SSO_BUTTON = 'reimbursify-sso-button';
export const HIDE_REIMBURSIFY_SSO_UPGRADE = 'hide-reimbursify-sso-upgrade';
export const ACCOUNT_ENABLE_SSO_UPGRADE_CURRENT_REIMBURSIFY =
  'account-enable-sso-upgrade-current-reimbursify';
